import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getIsLoading } from "../../../application/selectors/ui";
import Icon from "../shared/icon";
import LoadingWrapper from "../shared/loading";
import DashboardBlocksRenderer from "./DashboardBlocksRenderer";

const Dashboard = ({
  menuList = [],
  cartTitle,
  blockList = [],
  loading = false,
}) => {
  const isLoading = useSelector(getIsLoading);

  return (
    <Grid container className="home-container" spacing={2}>
      {menuList?.length ? (
        <Grid item xs={12} md={12}>
          <Card>
            <CardHeader title={cartTitle} />
            <CardContent>
              <Grid container spacing={2}>
                {React.Children.toArray(
                  Array.isArray(menuList) &&
                    menuList
                      .filter((x) => x.title !== "داشبورد")
                      .map((menu) => (
                        <Grid item xs={6} sm={4} md={3} lg={2}>
                          <Link to={menu.link}>
                            <div className={"stat"}>
                              <div className="stat-icon-container">
                                <Icon name={menu.icon} link={menu.link} />
                              </div>
                              <div className="stat-detail-container">
                                <div className="stat-title">{menu.title}</div>
                                <div className="stat-description">
                                  {menu.description || ""}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </Grid>
                      ))
                )}

                {isLoading && (
                  <Grid item xs={12} md={12}>
                    <LoadingWrapper />
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ) : null}

      <DashboardBlocksRenderer
        blockList={blockList}
        cartTitle={cartTitle}
        loading={loading || isLoading}
      />
    </Grid>
  );
};

export default Dashboard;
